exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.notification__item--round a {\n  height: auto !important;\n  padding: 10px;\n}\n", "", {"version":3,"sources":["/var/www/appv1.carnet-info-logement.com/src/components/header-notifications-item/HeaderNotificationsItem.vue"],"names":[],"mappings":";AAKG;EAEG,wBAAuB;EACvB,cAAa;CACd","file":"HeaderNotificationsItem.vue","sourcesContent":["\n\n\n\n.notification__item {\n  &--round {\n    a {\n      height: auto !important;\n      padding: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9b27cc4a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1&bustCache!./src/components/header-notifications-item/HeaderNotificationsItem.vue
// module id = F99L
// module chunks = 0